



























































































































import { forEach, throttle, debounce, last, map } from 'lodash-es'
import A from '@/utilities/alpha'
import SharedReportNav from '../components/SharedReports/SharedReportNav.vue'
import IntroDisplay from '../components/SharedReports/IntroDisplay.vue'
import CardDisplay from '../components/SharedReports/CardDisplay.vue'
import SectionDisplay from '../components/SharedReports/SectionDisplay.vue'
import PrototypesDisplay from '../components/SharedReports/PrototypesDisplay.vue'
import $ from 'jquery'
import api from '@/api'
import store from '@/store'
import SharedReportModal from '../components/SharedReports/SharedReportModal.vue'
import SummaryDisplay from '../components/SharedReports/SummaryDisplay.vue'
import CtaDisplay from '../components/SharedReports/CTADisplay.vue'
import CtaDownload from '../components/SharedReports/CTADownload.vue'
import CtaShare from '../components/SharedReports/CTAShare.vue'
import MassAssetToggle from '../components/SharedReports/MassAssetToggle.vue'
import EditBackgroundModal, { BackgroundTypeDefault, DefaultBackgroundImage } from '../components/SharedReports/EditBackgroundModal.vue'
import { reportSourceType } from '@/utilities/test-helpers.js'
import { format } from '@/utilities/audience-helpers.js'
import { Vue, Component, Watch } from 'vue-property-decorator'
import loadingGif from '@/assets/img/loading.gif'
import { Button } from '@alpha/ink'
import { processQuestion } from '@/utilities/shared-report-helpers.js'
import analytics from '@/analytics'

export interface Window {
  [key:string]: any; // Add index signature
}

@Component({
  metaInfo () {
    return {
      link: [
        {
          rel: 'stylesheet',
          href: 'https://stackpath.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css',
          integrity: 'sha384-HSMxcRTRxnN+Bdg0JdbxYKrThecOKuH5zCYotlSAcp1+c8xmyTe9GYg1l9a69psu',
          crossorigin: 'anonymous'
        },
        {
          rel: 'stylesheet',
          href: 'https://stackpath.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap-theme.min.css',
          integrity: 'sha384-6pzBo3FDv/PJ8r2KRkGHifhEocL+1X2rVCTTkUfGk7/0pbek5mMa1upzvWbrUbOZ',
          crossorigin: 'anonymous'
        },
        {
          rel: 'stylesheet',
          href: 'https://cdnjs.cloudflare.com/ajax/libs/selectize.js/0.12.3/css/selectize.bootstrap3.min.css',
          crossorigin: 'anonymous'
        }
      ]
    }
  },
  components: {
    SharedReportNav,
    IntroDisplay,
    CardDisplay,
    SectionDisplay,
    PrototypesDisplay,
    SummaryDisplay,
    CtaDisplay,
    CtaDownload,
    MassAssetToggle,
    CtaShare,
    EditBackgroundModal,
    SharedReportModal,
    Button
  }
})
export default class SharedReports extends Vue {
  reportOriginal:any = { config: { type: 'view' } }
  editable:boolean = true
  editId:boolean | string = true
  exportEagleUrl:string = ''
  assetLoc:any = {}
  loggedIn:boolean = true
  referenceId:string = ''
  loading:boolean = true

  loadingGif = loadingGif

  accountId:any = ''
  pages:any = []
  activePage:any = null
  modal:any = false
  modalHeader:string = ''
  window:Window = window
  report:any = false
  reportType:boolean | string = (this.reportOriginal.config && this.reportOriginal.config.type) || 'view'
  showAnchor:boolean = false
  scrollPosition:any = 0
  audiencesToFetch:any = []
  showEditBackgroundModal:boolean = false
  showModal:boolean = false

  @Watch('report')
  addDisplayOrder ():void {
    // <CardDisplay/> and <SectionDisplay/> will be given backup displayOrder values,
    // but this method should create the source of truth in report.orphans and report.sections.
    const anyGivenTest = this.report.orphans.length > 0 ? this.report.orphans[0] : this.report.sections[0].questions[0]
    if (anyGivenTest.displayOrder === undefined) {
      const updateQuestion = (question:any, index:number):void => {
        Vue.set(question, 'displayOrder', index + 1) // offset to account for section headers
      }
      this.report.orphans.forEach(updateQuestion)
      this.report.sections.forEach((section:any, index:any) => {
        const adjustForOrphans = this.report.orphans.length > 0 ? 1 : 0
        Vue.set(section, 'displayOrder', index + adjustForOrphans)
        section.questions.forEach(updateQuestion)
      })
    }
    Vue.nextTick(this.calculateScrolls)
  }

  get session () {
    return store.state.user.authenticatedUser
  }

  get summary ():any {
    var data:any = {
      people: 0,
      testTypes: {},
      prototypes: 0,
      assets: [],
      questions: 0
    }

    var uniquePrototypes:any = {}
    var uniqueAssets:any = {}

    var orphans = this.report.orphans
    processQuestions(orphans)

    var sections = this.report.sections
    if (sections && sections.length > 0) {
      sections.forEach(function (section:any) {
        if (section.export) {
          var questions = section.questions
          processQuestions(questions)
        }
      })
    }

    function processQuestions (questions:any) {
      if (questions && questions.length > 0) {
        questions.forEach(function (question:any) {
          if (question.export) {
            addData(question)
          }
        })
      }
    }

    function addData (question:any) {
      var numPeople = parseInt(question.payload.people, 10)
      if (numPeople) {
        data.people = data.people + numPeople
      }
      data.testTypes[question.payload.testType] = (data.testTypes[question.payload.testType] || 0) + 1
      if (question.payload.prototypes) {
        Object.keys(question.payload.prototypes).forEach(function (prototypeKey) {
          var protoUrl = question.payload.prototypes[prototypeKey].url
          if (!uniquePrototypes[protoUrl]) {
            uniquePrototypes[protoUrl] = 1
            data.prototypes++
          }
        })
      }
      if (question.payload.assets) {
        Object.keys(question.payload.assets).forEach(function (assetKey:any) {
          var asset = question.payload.assets[assetKey]
          var assetUrl = asset.url || asset.hostedCsv // use hostedCSV for uniqueness of sliced data
          if (!uniqueAssets[assetUrl] && asset.export) {
            uniqueAssets[assetUrl] = 1
            data.assets.push(question.payload.assets[assetKey])
          }
        })
      }
      data.questions = data.questions + 1
    }

    return data
  }

  get canEdit (): boolean {
    if (!this.session) return false
    return this.session.email === this.report.client.email
  }

  get downloadURL ():string {
    return `/report/${this.referenceId}/export/pdf`
  }

  get editURL ():string {
    return `/${this.report.client.id}/report/${this.referenceId}/edit`
  }

  get displayShare ():boolean {
    // commenting out intro page stuff for now. may bring back later
    if (this.pages.length === 0) return false
    return true
    // return this.pages[1] ? this.scrollPosition > this.pages[1].scrollPosition : true
  }

  get displayAnchor ():boolean {
    if (!this.showAnchor) return this.showAnchor
    if (this.pages.length === 0) return false

    var summaryPage:any = last(this.pages)
    // var secondPage = this.pages[1] || this.pages[0]
    return this.showAnchor && this.scrollPosition < summaryPage.scrollPosition
    // && this.scrollPosition > secondPage.scrollPosition
  }

  async mounted () {
    const that = this
    // Grab data from legacy api to populate reports, use the route to determine what data to load
    // Nelson TODO: Dry out this code to use less ifs
    if (that.$router.currentRoute.name === 'sharedReportPreviewProject') {
      await api.sharedReportPreviewProjects(that.$router.currentRoute.params.workspaceId, that.$router.currentRoute.params.projectId).then(response => {
        forEach(response.data.reportOriginal.orphans, function (orphan) {
          processQuestion(orphan)
        })

        forEach(response.data.reportOriginal.sections, function (section) {
          forEach(section.questions, function (question) {
            processQuestion(question)
          })
        })
        // Set data properties using the componentProps
        that.reportOriginal = response.data.reportOriginal
        that.editable = response.data.editable
        that.editId = response.data.editId
        that.exportEagleUrl = response.data.exportEagleUrl
        that.assetLoc = response.data.assetLoc
        that.loggedIn = response.data.loggedIn
        that.referenceId = response.data.referenceId
        that.accountId = response.data.accountId

        that.window.addEventListener('beforeunload', that.preventUnload)
        that.window.addEventListener('hashchange', that.urlHashChanged, false)
        that.window.assetLoc = that.assetLoc
        that.reportType = (response.data.reportOriginal.config && response.data.reportOriginal.config.type) || 'view'
        that.report = that.generateReport()
        // Global analytics setup
        // if (that.window.alphalytics) {
        //   const sourceType = reportSourceType(that.reportOriginal)
        //   that.window.alphalytics.injectedConfig.sourceType = sourceType
        //   if (sourceType === 'experiment') {
        //     that.window.alphalytics.injectedConfig.experimentId = that.reportOriginal.config.id
        //   }
        // }
        that.loading = false
      })
    }

    if (that.$router.currentRoute.name === 'sharedReportPreviewTest') {
      await api.sharedReportPreviewTests(that.$router.currentRoute.params.workspaceId, that.$router.currentRoute.params.testId).then(response => {
        forEach(response.data.reportOriginal.orphans, function (orphan) {
          processQuestion(orphan)
        })

        forEach(response.data.reportOriginal.sections, function (section) {
          forEach(section.questions, function (question) {
            processQuestion(question)
          })
        })
        // Set data properties using the componentProps
        that.loading = false
        that.reportOriginal = response.data.reportOriginal
        that.editable = response.data.editable
        that.editId = response.data.editId
        that.exportEagleUrl = response.data.exportEagleUrl
        that.assetLoc = response.data.assetLoc
        that.loggedIn = response.data.loggedIn
        that.referenceId = response.data.referenceId
        that.accountId = response.data.accountId
        that.reportType = (response.data.reportOriginal.config && response.data.reportOriginal.config.type) || 'view'

        that.window.addEventListener('beforeunload', that.preventUnload)
        that.window.addEventListener('hashchange', that.urlHashChanged, false)
        that.window.assetLoc = that.assetLoc
        that.report = that.generateReport()
        // Global analytics setup
        // if (that.window.alphalytics) {
        //   const sourceType = reportSourceType(that.reportOriginal)
        //   that.window.alphalytics.injectedConfig.sourceType = sourceType
        //   if (sourceType === 'experiment') {
        //     that.window.alphalytics.injectedConfig.experimentId = that.reportOriginal.config.id
        //   }
        // }
      })
    }
    if (that.$router.currentRoute.name === 'viewSharedReport') {
      await api.viewSharedReport(that.$router.currentRoute.params.reportId).then(response => {
        forEach(response.data.reportOriginal.orphans, function (orphan) {
          processQuestion(orphan)
        })

        forEach(response.data.reportOriginal.sections, function (section) {
          forEach(section.questions, function (question) {
            processQuestion(question)
          })
        })
        // Set data properties using the componentProps
        that.loading = false
        that.reportOriginal = response.data.reportOriginal
        that.editable = response.data.editable
        that.editId = response.data.editId

        that.exportEagleUrl = response.data.exportEagleUrl
        that.assetLoc = response.data.assetLoc
        that.loggedIn = response.data.loggedIn
        that.referenceId = response.data.referenceId
        that.accountId = response.data.accountId
        that.reportType = (response.data.reportOriginal.config && response.data.reportOriginal.config.type) || 'view'

        that.window.addEventListener('beforeunload', that.preventUnload)
        that.window.addEventListener('hashchange', that.urlHashChanged, false)
        that.window.assetLoc = that.assetLoc
        that.report = this.generateReport()
        // Global analytics setup
        // if (this.window.alphalytics) {
        //   const sourceType = reportSourceType(this.reportOriginal)
        //   this.window.alphalytics.injectedConfig.sourceType = sourceType
        //   if (sourceType === 'experiment') {
        //     this.window.alphalytics.injectedConfig.experimentId = this.reportOriginal.config.id
        //   }
        // }
      })
      document.title = `${that.report.title} - Feedback Loop`
    }

    if (that.$router.currentRoute.name === 'editSharedReport') {
      await api.editSharedReport(that.$router.currentRoute.params.workspaceId, that.$router.currentRoute.params.reportId).then(response => {
        forEach(response.data.reportOriginal.orphans, function (orphan) {
          processQuestion(orphan)
        })

        forEach(response.data.reportOriginal.sections, function (section) {
          forEach(section.questions, function (question) {
            processQuestion(question)
          })
        })
        // Set data properties using the componentProps
        that.loading = false
        that.reportOriginal = response.data.reportOriginal
        that.editable = response.data.editable
        that.editId = response.data.editId
        that.exportEagleUrl = response.data.exportEagleUrl
        that.assetLoc = response.data.assetLoc
        that.loggedIn = response.data.loggedIn
        that.referenceId = response.data.referenceId
        that.accountId = response.data.accountId
        that.reportType = (response.data.reportOriginal.config && response.data.reportOriginal.config.type) || 'view'

        that.window.addEventListener('beforeunload', that.preventUnload)
        that.window.addEventListener('hashchange', that.urlHashChanged, false)
        that.window.assetLoc = that.assetLoc
        that.report = that.generateReport()
        // Global analytics setup
        // if (this.window.alphalytics) {
        //   const sourceType = reportSourceType(this.reportOriginal)
        //   this.window.alphalytics.injectedConfig.sourceType = sourceType
        //   if (sourceType === 'experiment') {
        //     this.window.alphalytics.injectedConfig.experimentId = this.reportOriginal.config.id
        //   }
        // }
      })
    }

    // Calculate all the pages that will exist.
    this.calculateScrolls()
    this.calculatePosition()
    // Page listeners
    // var that = this
    // Keep scroll positions accurate
    $(this.window).on('resize', debounce(function () {
      that.calculateScrolls()
      that.calculatePosition()
    }, 200))

    if (this.window.supportsPassive) {
      this.window.addEventListener('scroll', debounce(function () {
        that.calculateScrolls()
        that.calculatePosition()
      }, 300, { trailing: true }), { passive: true })
    } else {
      $(this.window).on('scroll', debounce(function () {
        that.calculateScrolls()
        that.calculatePosition()
      }, 300, { trailing: true }))
    }

    if (this.window.supportsPassive) {
      this.window.addEventListener('scroll', throttle(function () {
        that.calculateScrollPosition()
      }, 100, { trailing: true }), { passive: true })
    } else {
      $(this.window).on('scroll', debounce(function () {
        that.calculateScrollPosition()
      }, 100, { trailing: true }))
    }

    // Key bindings
    $(document).on('keyup', function (e:any) {
      if ($(e.target).hasClass('editing-response')) {
        return
      }
      switch (e.which) {
        case 39: // right
          that.scroll('next')
          break
        case 37: // left
          that.scroll('prev')
          break
        default:
      }
    })

    // toggle anchor after everything's been loaded
    this.showAnchor = true

    // Analytics
    if (this.editable && !this.editId) {
      analytics.track('Shared Report Builder Viewed', {
        sourceId: this.reportOriginal.config ? this.report.config.id : this.reportOriginal.client.viewId,
        test_type: this.reportOriginal.testType,
        sourceType: reportSourceType(this.reportOriginal)
      })
    } else {
      analytics.track('Shared Report Viewed', {
        title: this.reportOriginal.title,
        sourceId: this.reportOriginal.config ? this.reportOriginal.config.id : this.reportOriginal.client.viewId,
        tapName: this.reportOriginal.client.name,
        tapId: this.reportOriginal.client.id,
        authorEmail: this.reportOriginal.client.email,
        authorId: this.reportOriginal.client.authorId,
        test_type: this.reportOriginal.testType,
        sourceType: reportSourceType(this.reportOriginal)
      })
    }
  }

  urlHashChanged () {
    var that = this
    var assetId = this.window.location.hash
    var assetOrphanIndex = -1
    if (assetId[0] === '#') {
      assetId = assetId.slice(1)
    }
    var intAsssetId = parseInt(assetId)
    if (assetId && assetId.length > 0) {
      if (that.report.orphans && that.report.orphans.length > 0) {
        that.report.orphans.forEach(function (question:any, index:any) {
          if (Object.keys(question.payload.assets).length > 0) {
            if (question.payload.assets[intAsssetId]) {
              assetOrphanIndex = index
            }
          }
        })
      }
      if (assetOrphanIndex > -1) {
        const orphans:any = this.$refs.orphans
        var assetComponent:any = orphans[assetOrphanIndex].$refs.accordion.$refs[intAsssetId]
        var scrollOffset = this.editable ? 45 : 15
        this.window.location.hash = '1' // Why 1? if we update it to empty it scrolls up and then down. instead of just down.
        const $$:any = $
        $$('body, html').animate({
          scrollTop: $$(assetComponent[0].$el).offset().top - scrollOffset // Always get a fresh scroll position
        }, function () {

        })
      }
    }
  }

  preventUnload (event:any) {
    // https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onbeforeunload
    if (this.editable) {
      // Triggers the confirm alert
      event.preventDefault()
      event.returnValue = ''
    }
  }

  async loadAudienceData () {
    if (this.audiencesToFetch.length === 0) return
    // Only doing this here so that the async doesnt hold up direcrting user to this route initially
    await store.dispatch.updateWorkspace(this.$router.currentRoute.params.workspaceId)
    if ((!store.state.user.acl || store.state.user.acl.id !== store.state.accountId) && store.state.accountId) {
      store.dispatch.user.fetchAcl(store.state.accountId)
    }
    api.getAudiencesById(store.state.workspace.workspace.id, store.state.accountId as string, this.audiencesToFetch)
      .then(response => response.data)
      .then(data => {
        const audienceMap:any = {}
        data.audiences.forEach((audience:any) => {
          const aud = format.forBuilder(audience.id, audience)
          audienceMap[aud.id] = aud
        })
        this.addAudiencesToReport(audienceMap)
      })
      .catch((err) => {
        console.error('Error loading audience data', err)
      })
  }

  addAudiencesToReport (audienceMap:any) {
    this.report.orphans.forEach((question:any, qIdx:any) => {
      const segment = typeof question.payload.segment === 'object' ? question.payload.segment.id : question.payload.segment
      const audience = audienceMap[segment]
      if (audience) {
        this.$set(this.report.orphans[qIdx].payload, 'segment', audience)
      }
    })
    this.report.sections.forEach((section:any, sIdx:any) => {
      section.questions.forEach((question:any, qIdx:any) => {
        const segment = typeof question.payload.segment === 'object' ? question.payload.segment.id : question.payload.segment
        const audience = audienceMap[segment]
        if (audience) {
          this.$set(this.report.sections[sIdx].questions[qIdx].payload, 'segment', audience)
        }
      })
    })
  }

  processTextAnswersForPublish (answers:any, blacklist:any) {
    answers.forEach((answer:any) => {
      if (answer.type === 'answer' && !answer.show && answer.rid) {
        blacklist.add(answer.rid)
      }
      if (answer.type === 'group') {
        this.processTextAnswersForPublish(answer.children, blacklist)
      }
    })
  }

  processAssetsForPublish (originalAssets:any) {
    // Remove text response data before publishing, replace with RID blacklist so this can be rebuilt on the fly
    // Done so that we can reduce the size of reports
    const assets = A.clone(originalAssets)
    Object.entries(assets).forEach(asset => {
      const [key, value]:any = asset
      const textResponses = value.textResponses
      const ridBlacklist = new Set()
      let setBlacklist = false
      if (textResponses) {
        Object.entries(textResponses).forEach(textSlice => {
          const [sliceKey, sliceValue]:any = textSlice
          if (sliceValue.asset_type === 'text-slice') {
            if (!sliceValue.responses || !sliceValue.responses.answers) {
              return
            }
            // We only want to modify the blacklist for assets that the user conceivably edited
            // text-slice assets that don't have answers in them are assets that were not yet loaded on the page.
            setBlacklist = true
            this.processTextAnswersForPublish(sliceValue.responses.answers, ridBlacklist)
            delete sliceValue.responses.answers
            textResponses[sliceKey] = sliceValue
          }
        })
      }
      if (setBlacklist) {
        value.ridBlacklist = Array.from(ridBlacklist)
        assets[key] = value
      }
    })
    return assets
  }

  generateReport ():any {
    const that = this
    const cloned = JSON.parse(JSON.stringify(this.reportOriginal))

    // Add background to legacy reports
    if (!cloned.background) {
      cloned.background = {
        type: BackgroundTypeDefault.IMAGE,
        imageURL: DefaultBackgroundImage,
        color: null
      }
    }

    if (!that.editable) {
      // When this is a published report, we just need to add any missing properties that have been added over time
      return that.upgradeReport(cloned)
    }

    cloned.orphans = cloned.orphans.filter(filterQuestions)

    // cloned.theme = cloned.theme || 'calm'

    processQuestions(cloned.orphans)
    cloned.sections.forEach(function (section:any) {
      // eslint-disable-next-line no-prototype-builtins
      if (!section.hasOwnProperty('export')) {
        section.export = true
      }
      section.questions = section.questions.filter(filterQuestions)
      processQuestions(section.questions)
    })
    this.loadAudienceData()
    function filterQuestions (question:any):any {
      // current filter is just anything that's further along than In Review
      return !['Draft', 'In Review'].includes(question.payload.status)
    }

    function processQuestions (questions:any) {
      if (questions && questions.length) {
        questions.forEach(function (question:any) {
          // Export everything that's complete by default
          // If editing an existing report it'll already have the property, respect that
          // eslint-disable-next-line no-prototype-builtins
          if (!question.hasOwnProperty('export')) {
            question.export = that.reportType === 'card' || question.payload.status === 'Complete' || Object.keys(question.payload.assets).length
          }
          // eslint-disable-next-line no-prototype-builtins
          if (!question.hasOwnProperty('assetOrder')) {
            question.assetOrder = that.computeInitialAssetOrder(question)
          }
          processAssets(question)
          processPrototypes(question)

          // only load audiences on report creation i.e. /sharePreview
          if (!that.referenceId && typeof question.payload.segment === 'object' && question.payload.segment.id) {
            that.audiencesToFetch.push(question.payload.segment.id)
          }
        })
      }
    }

    function processPrototypes (question:any) {
      var protos = question.payload.prototypes
      if (protos) {
        Object.keys(protos).forEach(function (protoId) {
          var proto = protos[protoId]
          // By default, every prototype should be exported
          // eslint-disable-next-line no-prototype-builtins
          if (!proto.hasOwnProperty('export')) {
            proto.export = true
          }
        })
      }
    }

    function processAssets (question:any) {
      var assets = question.payload.assets
      var hasDynamics = false // Flag for whether we've processed dynamic qual assets before
      if (assets) {
        Object.keys(assets).forEach(function (assetId) {
          var asset = assets[assetId]
          // Set key insights by default to export
          // If editing an existing report it'll already have the property, respect that
          // eslint-disable-next-line no-prototype-builtins
          if (!asset.hasOwnProperty('export')) {
            asset.export = true
          }
          if (asset.dynamicQual) {
            hasDynamics = true
          }
        })
      }
      // Add dynamic qual notables
      if (question.payload.qualNotable && !hasDynamics) {
        var now = +new Date()
        question.payload.qualNotable.forEach(function (notable:any, idx:any) {
          var thisId = now + idx
          var questionNumber = notable.questionNumber
          var questionText = notable.questionText
          var notableAsset:any = {
            alphaAnalysis: '',
            responses: {
              answers: [],
              notes: '',
              subtitle: 'Representative Responses',
              title: (questionNumber + 1) + '. ' + questionText,
              type: 'textResponses'
            },
            asset_type: 'textResponses',
            dynamicQual: true,
            filename: '',
            id: thisId,
            url: '',
            export: true
          }
          // TODO: optimizations
          Object.keys(question.payload.assets).forEach(function (assetKey:any, idx:any) {
            var asset = question.payload.assets[assetKey]
            if (asset.asset_type === 'video') {
              var notes = asset.logger_notes
              if (A.isJsonString(notes)) {
                notes = JSON.parse(notes)
              }
              if (notes && notes[questionNumber] && notes[questionNumber].question === questionText) {
                notableAsset.responses.answers.push({
                  content: 'Session ' + (asset.session_id || '????') + ' ' + notes[questionNumber].answer,
                  show: true,
                  id: idx,
                  type: 'answer'
                })
              }
            }
          })
          notableAsset.responses.subtitle = 'Sample size: ' + notableAsset.responses.answers.length + ' users'
          assets[thisId] = notableAsset
        })
      }
    }
    // console.log(cloned)
    return cloned
  }

  upgradeReport (report:any) {
    var that = this
    if (report.orphans) {
      report.orphans.forEach(upgradeQuestion)
    }

    if (report.sections) {
      report.sections.forEach(function (section:any) {
        if (section.questions) {
          section.questions.forEach(upgradeQuestion)
        }
      })
    }

    function upgradeQuestion (question:any):any {
      // If already has new, leave it
      if (question.assetOrder) {
        return
      }
      question.assetOrder = that.computeInitialAssetOrder(question)
    }

    return report
  }

  computeInitialAssetOrder (question:any):any {
    if (!question.payload.assets) {
      return []
    }

    return map(question.payload.assets, function (val, key, arr) {
      return key
    })
  }

  scrollTo (item:any) {
    if (item) {
      var scrollOffset = this.editable ? 45 : 15
      const currentElOffset = $(item.page.$el).offset() || { top: 0 }
      $('body, html').animate({
        scrollTop: currentElOffset.top - scrollOffset // Always get a fresh scroll position
      })
    }
  }

  scroll (direction:any) {
    var nextPage
    var currentPosition = ($(document).scrollTop() as number) + 50 // Allow a little offset from the top
    var pages = this.pages

    function isAtFirstPage (i:any):any {
      return i === 0 && currentPosition <= pages[i].scrollPosition
    }

    for (var i = 0; i < pages.length; i++) {
      // If we've reached the last page, mark that we're there.
      if (i === pages.length - 1) {
        nextPage = direction === 'next' ? false : pages[i - 1]
        break
      }
      if (isAtFirstPage(i) || (pages[i].scrollPosition <= currentPosition && pages[i + 1].scrollPosition > currentPosition)) {
        nextPage = direction === 'next' ? pages[i + 1] : pages[i - 1]
        break
      }
    }
    this.scrollTo(nextPage)
  }

  calculateScrolls () {
    var pageEls = [{ type: 'intro', page: this.$refs.intro, displayOrder: -2000 }]
    if (this.$refs.orphans) {
      processQuestionsForPage(this.$refs.orphans)
    }
    if (this.$refs.sections) {
      const sections:any = this.$refs.sections
      sections.forEach(function (section:any, index:number) {
        if (section.$el.nodeType === Node.ELEMENT_NODE && section.$refs.questions) { // must be an element, not a comment or string or w/e
          pageEls.push({ type: 'section', page: section, displayOrder: index })
          processQuestionsForPage(section.$refs.questions)
        }
      })
    }
    function processQuestionsForPage (questions:any) {
      if (questions && questions.length) {
        questions.forEach(function (question:any, index:number) {
          if (question && question.$el && question.$el.nodeType === Node.ELEMENT_NODE) { // must be an element, not a comment or string or w/e
            pageEls.push({ type: 'question', page: question, displayOrder: question.displayOrder })
          }
        })
      }
    }
    const prototypes:any = this.$refs.prototypes
    if (prototypes && prototypes.$el.nodeType !== Node.COMMENT_NODE) { // 8 is a comment
      pageEls.push({ type: 'prototypes', page: prototypes, displayOrder: 2000 })
    }
    const summary = this.$refs.summary
    pageEls.push({ type: 'summary', page: summary, displayOrder: 3000 })
    // Now get scroll positions for each
    const pages:any = []
    pageEls.forEach(function (pageEl:any) {
      if (pageEl.page) {
        const scPage:any = pageEl.page
        const scPageOffSet = $(scPage.$el).offset() || { top: 0 }
        var scrollTop = scPageOffSet.top - 20
        const { displayOrder } = pageEl
        pages.push({
          scrollPosition: scrollTop,
          page: scPage,
          type: pageEl.type,
          displayOrder
        })
      }
    })
    this.pages = pages
  }

  calculatePosition () {
    this.pages.sort((a:any, b:any) => {
      return a.scrollPosition - b.scrollPosition
    })
    var currentPage
    var currentPosition = ($(document).scrollTop() as number) + 50 // Allow a little offset from the top
    for (var k = 0; k < this.pages.length; k++) {
      if (k === this.pages.length - 1) {
        currentPage = this.pages[k]
        break
      }
      if (currentPosition > this.pages[k].scrollPosition && currentPosition < this.pages[k + 1].scrollPosition) {
        currentPage = this.pages[k]
        break
      }
    }
    this.activePage = currentPage
  }

  calculateScrollPosition () {
    this.scrollPosition = $(document).scrollTop()
  }

  expandAsset (asset:any) {
    this.modal = asset
  }

  closeModal () {
    this.showModal = false
  }

  massSelectAssets (group:any) {
    var targetState = group === 'all' // If all, then we want everything to be true.
    this.report.sections && this.report.sections.forEach(function (section:any) {
      section.export = targetState
      section.questions && section.questions.forEach(toggleQuestion)
    })

    this.report.orphans && this.report.orphans.forEach(toggleQuestion)

    function toggleQuestion (question:any) {
      question.export = targetState
      question.payload.assets && forEach(question.payload.assets, function (asset:any) {
        asset.export = targetState
      })
    }
  }

  processReport (report:any):any {
    const that = this
    var clone = JSON.parse(JSON.stringify(report))
    clone.title = A.stripHTML(clone.title)
    clone.sections && clone.sections.forEach(function (section:any) {
      section.title = A.stripHTML(section.title)
      section.questions && section.questions.forEach((question:any) => {
        question.payload.assets = that.processAssetsForPublish(question.payload.assets)
        question.payload.title = A.stripHTML(question.payload.title)
      })
    })
    clone.orphans && clone.orphans.forEach((question:any) => {
      const { title } = question.payload
      question.payload.assets = that.processAssetsForPublish(question.payload.assets)
      question.payload.title = A.stripHTML(title)
    })
    clone.extraProp = 'isPresent'
    return clone
  }

  editReport () {
    var data = JSON.stringify(this.processReport(this.report))
    let sourceId:any
    if (this.reportType === 'card') {
      sourceId = this.report.config.id
    } else {
      sourceId = this.report.config ? this.report.config.id : this.report.client.viewId
    }
    const editUrl = `/${this.report.client.id}/report/${this.editId}/edit`

    var that = this
    api.publishEditReport(editUrl, data)
      .then(function (res:any) {
        analytics.track('Shared Report Updated', {
          sourceId: sourceId,
          sharedReportId: res,
          sourceType: reportSourceType(that.report)
        })
        that.modalHeader = 'Report Updated'
        that.modal = window.location.protocol + '//' + window.location.host + '/report/' + res.data
        that.showModal = true
      })
  }

  publishReport () {
    var processed = this.processReport(this.report)
    var data = JSON.stringify(processed)
    // console.log(this.report)
    var publishUrl:any, sourceId:any
    if (this.reportType === 'card') {
      sourceId = this.report.config.id
      publishUrl = `/${this.report.client.id}/report/test/${sourceId}/publish/`
    } else {
      sourceId = this.report.config ? this.report.config.id : this.report.client.viewId
      publishUrl = `/${this.report.client.id}/report/experiment/${sourceId}/publish/`
    }

    var that = this
    api.publishEditReport(publishUrl, data)
      .then(function (res:any) {
        analytics.track('Shared Report Created', {
          sourceId: sourceId,
          sharedReportId: res,
          test_type: that.reportOriginal.testType,
          sourceType: reportSourceType(that.report)
        })
        that.modalHeader = 'Report Published'
        that.modal = window.location.protocol + '//' + window.location.host + '/report/' + res.data
        that.showModal = true
      })
  }

  updateAsset ({ cardIdx, asset, key }:any) {
    this.$set(this.report.orphans[cardIdx].payload.assets, key, asset)
  }

  testsReorder ({ drag, drop }:any):void {
    // Important: this method assumes we are working within a singular section/orphans, not across sections/orphans.
    const testContainer = drag.parentIdx === -1 ? this.report.orphans : this.report.sections[drag.parentIdx].questions
    const draggedTest = testContainer[drag.idx]
    if (drag.displayOrder > drop.displayOrder) {
      testContainer.forEach((test:any, i:number):void => {
        if (test.displayOrder >= drop.displayOrder && test.displayOrder < drag.displayOrder) {
          test.displayOrder++
        }
      })
      draggedTest.displayOrder = drop.displayOrder
    } else if (drag.displayOrder < drop.displayOrder) {
      testContainer.forEach((test:any, i:number):void => {
        if (test.displayOrder <= drop.displayOrder && test.displayOrder > drag.displayOrder) {
          test.displayOrder--
        }
      })
      draggedTest.displayOrder = drop.displayOrder
    }
    const that = this
    Vue.nextTick(() => {
      that.calculateScrolls()
      that.calculatePosition()
    })
  }
}
